import React from "react";
import AlertPopover from "components/Global/Alerts/Popover";
import Container from "components/Global/Alerts/Container";
import Paragraph from "components/Global/Alerts/ParagraphContainer";
import Separator from "components/Global/Alerts/Separator";
import ButtonContainer from "components/Global/Alerts/ButtonContainer";
import PrimaryAction from "components/Global/Alerts/PrimaryAction";
import SecondaryAction from "components/Global/Alerts/SecondaryAction";
import { noop } from "utils/General";

/**
 * @typedef {Object} AlertPopoverProps
 * @property {React.RefObject} anchorEl - The ref object for the anchor element
 * @property {Function} onClose - The function to call when the popover is closed
 * @property {boolean} open - Whether the popover is open
 * @property {Function} onConfirm - The function to call when the primary action is clicked
 */
const AlertPopoverComponent = ({
  anchorEl = null,
  onClose = noop,
  open = false,
  onConfirm = noop,
  title = null,
  primaryActionLabel,
  secondaryActionLabel = "Cancel",
  primaryActionDataCy = "confirmTask",
  tertiaryActionLabel = null,
  tertiaryActionDataCy = null,
  onConfirm2 = noop,
  widthContainer = 170
}) => {
  return (
    <AlertPopover anchorEl={anchorEl} onClose={onClose} open={open}>
      <Container width={widthContainer}>
        {title && (
          <Paragraph
            style={{ fontSize: 12, color: "#343434", fontWeight: 600 }}
          >
            {title}
          </Paragraph>
        )}
        {title && <Separator />}
        <ButtonContainer style={{ justifyContent: "space-between" }}>
          <PrimaryAction onClick={onConfirm} data-cy={primaryActionDataCy}>
            {primaryActionLabel}
          </PrimaryAction>
          {tertiaryActionLabel && (
            <PrimaryAction onClick={onConfirm2} data-cy={tertiaryActionDataCy}>
              {tertiaryActionLabel}
            </PrimaryAction>
          )}
          {secondaryActionLabel && (
            <SecondaryAction onClick={onClose}>
              {secondaryActionLabel}
            </SecondaryAction>
          )}
        </ButtonContainer>
      </Container>
    </AlertPopover>
  );
};

export default AlertPopoverComponent;
